import { ColumnDef } from '@tanstack/react-table'
import { GetCouponsDataResponse } from '@/modules/batches/type'
import { Badge } from '@/common/ui/badge'
import { Button } from '@/common/ui/button'
import { format } from 'date-fns'
import { Link } from 'react-router-dom'
import { History } from 'lucide-react'
import { CouponType } from '@/schema'

export const columns: ColumnDef<GetCouponsDataResponse>[] = [
	{
		accessorKey: 'code',
		header: 'รหัสคูปอง',
	},

	{
		accessorKey: 'status',
		header: 'สถานะ',
		cell: ({ row }) => {
			const variant = {
				USED: 'destructive',
				ACTIVE: 'default',
				EXPIRED: 'secondary',
			}[row.original.status] as 'destructive' | 'default' | 'secondary'

			const label = {
				USED: 'ใช้แล้ว',
				ACTIVE: 'ยังไม่ใช้',
				EXPIRED: 'หมดอายุ',
			}[row.original.status]

			return <Badge variant={variant}>{label}</Badge>
		},
	},
	{
		accessorKey: 'playerPhone',
		header: 'เบอร์โทรศัพท์ผู้ใช้งาน',
		cell: ({ row }) => {
			return <span>{row.original.playerPhone || '-'}</span>
		},
	},
	{
		accessorKey: 'usedAt',
		header: 'วันที่ใช้งาน',
		cell: ({ row }) =>
			row.original.usedAt
				? format(new Date(row.original.usedAt), 'dd/MM/yyyy HH:mm')
				: '-',
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) =>
			format(new Date(row.original.createdAt), 'dd/MM/yyyy HH:mm'),
	},
	{
		id: 'actions',
		header: 'ประวัติการใช้งาน',
		cell: ({ row }) => {
			// Only show usage history button for SINGLE type coupons
			if (row.original.type !== CouponType.SINGLE) {
				return null
			}

			return (
				<Button variant="ghost" size="icon" asChild>
					<Link to={`/operator/coupons/${row.original.id}/usage-history`}>
						<History className="h-4 w-4" />
					</Link>
				</Button>
			)
		},
	},
]
